export default __webpack_public_path__ + "static/media/Hoenn.612c97ad.png";